import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockVideos, mockCategories } from '@/mocks/videos';

export default function FeaturedVideos() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filtered = activeCategory === 'all'
    ? mockVideos.slice(0, 8)
    : mockVideos.filter(v => v.category === activeCategory).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">
              蘑菇视频编辑团队为您精心挑选的优质内容
            </p>
          </div>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
          <button
            onClick={() => setActiveCategory('all')}
            className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
              activeCategory === 'all'
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-50 text-foreground-600 hover:bg-background-200'
            }`}
          >
            全部
          </button>
          {mockCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {filtered.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category}`}
              className="group rounded-xl overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  title={`${video.title} - 蘑菇视频官网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  {video.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center mx-auto">
                    <i className="ri-play-fill text-background-50 text-lg"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 mb-1">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{video.year}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{video.views}次播放</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}